import { Outlet } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { HouseholdProvider } from "@/contexts/HouseholdContext";
import { I18nProvider } from "@/contexts/I18nContext";
import { ValuePropCarousel } from "@/components/features/ValuePropCarousel";
import { copyrightLine } from "@/lib/constants";

/**
 * Auth layout shared by sign-in and sign-up. Mobile: carousel hero on top,
 * form below. Desktop: side-by-side.
 *
 * Mounts AuthProvider + HouseholdProvider + I18nProvider so signed-out
 * users still get translated copy (Login / Register were extracted to
 * t() calls in PR #84). The locale resolves from cookie / navigator
 * since profile is null for unauthenticated users — matches iOS's
 * marketing-screen behavior.
 */
export function AuthLayout() {
  return (
    <AuthProvider>
      <HouseholdProvider>
        <I18nProvider>
          <div className="min-h-screen flex flex-col lg:flex-row bg-gray-50 dark:bg-gray-950">
            <div className="w-full lg:w-1/2 h-[40vh] lg:h-auto lg:min-h-screen p-4 lg:p-8 bg-gray-100 dark:bg-gray-900">
              <ValuePropCarousel />
            </div>
            <div className="w-full lg:w-1/2 flex flex-col">
              <div className="flex-1 flex items-center justify-center px-4 py-8 lg:p-8">
                <Outlet />
              </div>
              <footer className="px-4 py-4 text-center text-xs text-gray-500 dark:text-gray-400">
                {copyrightLine(true)}
              </footer>
            </div>
          </div>
        </I18nProvider>
      </HouseholdProvider>
    </AuthProvider>
  );
}
